import React, { useState, useEffect } from "react";
import { styled } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import "./common.css";
import API_URL from "../common/Apiurl";
import SuccessMessage from "../common/Message";
import Loader from "react-js-loader";
import DynamicQuestions from "./DynamicQuestions";

function Addindustry() {
  // add industry
  const apiUrl = API_URL;
  const navigate = useNavigate();
  const [industry, setindustry] = useState("");
  const [successMessages, setSuccessMessages] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [image, setImage] = useState({});
  const [is_image, setIsImage] = useState({});

  const clicktoaddindustry = async (e) => {
    setIsloading(true);
    e.preventDefault();
    // const postData = {
    //     industry_name: industry,
    // };
    const formData = new FormData();
    formData.append("industry_name", industry);
    // formData.append("image", image);
    // formData.append("is_image", is_image);
    const result = await fetch(`${apiUrl}/createindustry`, {
      method: "POST",
      // headers:{
      //     "Content-Type":"application/json",
      //     "Accept":"application/json"
      // },
      body: formData,
    });
    const data = await result.json();
    if (data.status == 200) {
      const newSuccessMessage = data.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
      setIsloading(false);
    } else if (data.status == 400) {
      const newSuccessMessage = data.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
    setindustry(" ");
  };

  const handleSuccessMessageFadeOut = () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
  };
  const inputArr = [
    {
      type: "text",
      id: 1,
      value: "",
    },
  ];

  const [arr, setArr] = useState(inputArr);

  const addInput = () => {
    setArr((s) => {
      return [
        ...s,
        {
          type: "text",
          value: "",
        },
      ];
    });
  };

  const handleChange = (e) => {
    e.preventDefault();

    const index = e.target.id;
    setArr((s) => {
      const newArr = s.slice();
      newArr[index].value = e.target.value;

      return newArr;
    });
  };
  // console.log(image)
  // add industry
  return (
    <div className="width90">
      <h2 className="pageTitle">Add Industry</h2>
      {isLoading ? (
        <Loader type="spinner-cub" title={"loading....."} size={100} />
      ) : (
        <div className="commonCntr">
          <div className="form-horizontal">
            <div className="form-group">
              <label
                className="control-label col-sm-2 label"
                htmlFor="industryname"
              >
                Industry Name:
              </label>
              <div className="col-sm-4">
                <input
                  type="text"
                  onChange={(e) => 
                    setindustry(e.target.value)
                  }
                  className="form-control"
                  id="industryname"
                  placeholder="Enter Industry name"
                  value={industry}
                />
              </div>
            </div>
            {/* <div className="form-group"> */}
              {/* <h3>Upload image</h3> */}
              {/* <label
                className="control-label col-sm-2 label"
                htmlFor="industryname"
              >
                Industry image:
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  setImage(e.target.files[0]);
                  setIsImage(true);
                }}
              /> */}
            {/* </div> */}
            {/* <DynamicQuestions industry_id={""} questionsList={[]}/> */}
            {/* <div className="form-group">
                        <label className="control-label col-sm-8 label" htmlFor="industryname">Add options for the role:</label>
                        <div className="row">
                            <div className="col-sm-3">
                                <button onClick={addInput}>Add more questions</button>                    
                            </div>
                            <div className="col-sm-8">
                            {arr.map((item, i) => {
                            return (
                            <input
                                onChange={handleChange}
                                value={item.value}
                                id={i}
                                type={item.type}
                                size="40"
                            />
                            );
                        })}
                            </div>
                        </div>
                    </div> */}

            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-10">
                <button
                  type="submit"
                  className="btn btn-default submitBtn"
                  onClick={clicktoaddindustry}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          {successMessages.map((message, index) => (
            <SuccessMessage
              key={index}
              message={message}
              onFadeOut={handleSuccessMessageFadeOut}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default Addindustry;
